module.exports = __webpack_public_path__ + "img/articles.a818de7b.svg";